import { Component, OnDestroy, OnInit, NgZone } from '@angular/core';
import { APIService } from '../../../api/api.service';
import { NotifierService } from '../../../_services/notifier.service';

import * as moment from 'moment';

declare let flatpickr: any;
declare let window: any;
declare let $: any;
@Component({
  templateUrl: './elastic.component.html',
})
export class ElasticCacheComponent implements OnInit, OnDestroy {
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  riData: any = [];
  updateRI: any;
  updateAction: any = 'update';

  accountId: any;
  regionId: any;
  currentMessage: any;
  unsavedRI: any = [];

  headers: any = [
    {
      id: 'instanceType',
      name: 'Cache Instance Type',
    },
    {
      id: 'engineType',
      name: 'Cache Engine Type',
    },
    {
      id: 'region',
      name: 'Region',
    },
    {
      id: 'nodeType',
      name: 'Node Type',
    },
    {
      id: 'quantity',
      name: 'Quantity',
    },
    {
      id: 'riType',
      name: 'RI Type',
    },
    {
      id: 'discount',
      name: 'Discount (%)',
    },
    {
      id: 'riHrCost',
      name: 'RI Hour Cost',
    },
    {
      id: 'startDate',
      name: 'Start Date',
    },
    {
      id: 'endDate',
      name: 'End Date',
    },
  ];

  funRef: any = {};
  deleteRI: any;
  unsavedUpdateId: number = -1;

  constructor(
    private notifier: NotifierService,
    private apiService: APIService
  ) {}

  ngOnInit(): void {
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');
    this.funRef = {};

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      }
    });
  }

  async load() {
    this.notifier.loading(true);

    let data = { accountId: this.accountId, action: 'fetchall' };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://dev.api.swayam.cloud/v3/admin/billing/elastic-cache-enable`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1' || result.s == '1') {
      this.riData = result.cfrcModels;
    } else {
      this.riData = [];
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  updateTrigger(id: any) {
    this.updateAction = 'update';
    this.updateRI = id;
  }

  deleteUnsavedRI(id: number) {
    this.unsavedRI.splice(id, 1);
  }

  updateUnsavedRI(id: any, index: number) {
    console.log('update during add', this.updateRI, this.unsavedUpdateId)
    this.updateAction = 'save';
    this.unsavedUpdateId = index;
    this.updateRI = id;
  }

  closeUpdateTrigger(event: any) {
    if (event) {
      if (this.updateAction == 'update') {
        this.load();
      } else {
        event.cfrcModels[0]['riHrCost'] =
          event.cfrcModels[0]['riHrCost'] == 'NA'
            ? 0.0
            : event.cfrcModels[0]['riHrCost'];
        if (this.unsavedUpdateId > -1) {
          this.unsavedRI[this.unsavedUpdateId] = event.cfrcModels[0];
          this.unsavedUpdateId = -1;
        } else {
          this.unsavedRI.push(event.cfrcModels[0]);
        }
      }
    }

    this.updateRI = null;
  }

  async deleteTrigger(id: any) {
    this.notifier.loading(true);
    let data: any = {
      accountId: this.accountId,
      action: 'delete',
cfrcModels: [
    {
      uuid: id.uuid
    }
  ]    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://dev.api.swayam.cloud/v3/admin/billing/elastic-cache-enable`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.load();
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.delete = false;
    this.notifier.loading(false);
  }

  closeDeleteTrigger(event: any) {
    this.deleteRI = null;
  }

  addPurchase() {
    this.updateAction = 'save';
    this.unsavedUpdateId = -1;
    // this.updateRI = {
    //   dbInstanceType: '',
    //   dbEngine: '',
    //   deploymentType: 'Single-AZ',
    //   region: this.regionId,
    //   riType: 'OnDemand',
    //   endDate: moment().startOf('day').format('YYYY-MM-DD'),
    //   startDate: moment().startOf('day').subtract(1).format('YYYY-MM-DD'),
    //   quantity: 0,
    //   id: window.uuidv4(),
    //   discountPercentage: '0',
    //   riHrCost: 0,
    // };
    
    this.updateRI = {
      instanceType: '',
      engineType: '',
      region: '',
      nodeType: '',
      quantity: '',
      riType: 'OnDemand',
      riHrCost: '',
      discount: '',
      startDate: '',
      endDate: ''

  }

  }

  async saveDetails() {
    this.notifier.loading(true);
    let data: any = {
      accountId: this.accountId,
      action: 'add',
      cfrcModels: this.unsavedRI.map((ri: any) => {
        Object.keys(ri).forEach((ri_: any) => {
          ri[ri_] = ri[ri_] || 'NA';
        });
        delete ri.id;
        ri.quantity = `${ri.quantity}`;
        return ri;
      }),
    };
    console.log('cfrcmodel', data.cfrcModels);
    let header = {
      Authorization: localStorage.getItem('t'),
    };

    let apiURL: string =
      'https://dev.api.swayam.cloud/v3/admin/billing/elastic-cache-enable';

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.unsavedRI = [];
      this.load();
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  
  indexdelete:any;
  delete: boolean =false;
  confirmdeletion(i:any){
    this.delete = true;
    this.indexdelete = i;
  }

  callFunction(param: any, id: any) {
    this.funRef[param](this, id);
  }

  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
  }
}
